'use strict';

module.exports = require('./es6/crcjam').default;
